import React, { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";

import { FullLogo } from "@/blocks/FullLogo";
import { RmCard, RmCardContent } from "@/components/RmCard";
import { RmText } from "@/components/RmText/RmText";
import { authSearchParamsSchema } from "@/domain/auth";
import { EmailLoginForm } from "@/interactors/EmailLoginForm";
import { OTPLoginForm } from "@/interactors/OTPLoginForm";
import { headWithCustomTitle } from "@/utils/router";

const LoginRoute = () => {
  const [email, setEmail] = useState("");

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background">
      <RmCard>
        <FullLogo className="mx-10" />

        <RmCardContent>
          <RmText
            variant="headerOne"
            i18nKey="main:login.signIn"
            className="mb-6"
          />

          {!email ? (
            <EmailLoginForm onSubmit={setEmail} />
          ) : (
            <OTPLoginForm email={email} onBack={() => setEmail("")} />
          )}
        </RmCardContent>
      </RmCard>
    </div>
  );
};

export const Route = createFileRoute("/_unauthed/login")({
  component: LoginRoute,
  validateSearch: authSearchParamsSchema,
  head: () => headWithCustomTitle("main:login.signIn"),
});
